import { render, staticRenderFns } from "./getMsg.vue?vue&type=template&id=416d6640&scoped=true&"
import script from "./getMsg.vue?vue&type=script&lang=js&"
export * from "./getMsg.vue?vue&type=script&lang=js&"
import style0 from "./getMsg.vue?vue&type=style&index=0&id=416d6640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d6640",
  null
  
)

export default component.exports